import { render, staticRenderFns } from "./playlist.vue?vue&type=template&id=3058c588"
import script from "./playlist.vue?vue&type=script&lang=ts"
export * from "./playlist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports